import React, { useState } from 'react'
import { Card, Modal, Space, Table, Tooltip } from 'antd'
import { EyeOutlined, DeleteOutlined } from '@ant-design/icons'
import { ErrorMessage } from '../../../Utils/Notification'
import {
    createPreSignedUrl,
    deleteFileFromServer,
} from '../../../Services/s3upload'
import { SaveArtical } from '../../../Services/wikiArtical'
import { useDispatch } from 'react-redux'
import { type ArticleData } from '../../../Types/wikiArtical'

const DocumentViewModelForm = (props: {
    data: string
    editData: ArticleData
    onclose: () => void
}): React.ReactElement => {
    const { data, editData, onclose } = props
    const [imagePath, setImagePath] = useState('')
    const [visible, setVisible] = useState(false)
    const dispatch = useDispatch()

    const Servicecolumns = [
        {
            title: 'File',
            dataIndex: 'attachmentPath',
            key: 'key',
        },
        {
            title: '',
            key: 'action',
            render: (_: any, record: any) => {
                return (
                    <Space size="middle">
                        <Tooltip title="View">
                            <EyeOutlined
                                onClick={() => {
                                    handleViewFile(record.key)
                                }}
                            />
                        </Tooltip>

                        <Tooltip title="Delete">
                            <DeleteOutlined
                                onClick={() => {
                                    void handleDeleteClick(record.key)
                                }}
                            />
                        </Tooltip>
                    </Space>
                )
            },
        },
    ]

    const getFileExtension = (url: string | undefined): string | undefined => {
        if (url != null) {
            return url.split('.').pop()?.toLowerCase()
        }
        return undefined
    }

    const handleViewFile = (imagePath: string): void => {
        void handleViewDocument(imagePath)
    }
    const handleViewDocument = async (imagePath: string): Promise<void> => {
        const preSignedUrl = await createPreSignedUrl(imagePath)
        if (preSignedUrl !== null) {
            const fileExtension = getFileExtension(imagePath)
            if (fileExtension === 'pdf') {
                viewPDF(preSignedUrl)
            } else if (
                fileExtension === 'jpg' ||
                fileExtension === 'jpeg' ||
                fileExtension === 'png'
            ) {
                viewImage(preSignedUrl)
            } else {
                ErrorMessage('Unsupported file format.')
            }
        }
    }
    const viewImage = (imageUrl: string): void => {
        setImagePath(imageUrl)
        setVisible(true)
    }

    const viewPDF = (pdfUrl: string): void => {
        setImagePath(pdfUrl)
        setVisible(true)
    }

    const handleDeleteClick = async (filePath: string): Promise<void> => {
        try {
            await deleteFileFromServer(filePath)
            const datatodave = {
                articleId: editData.articleId,
                articleGroupId: editData.articleGroupId,
                articleGroupName: editData.articleGroupName,
                articleName: editData.articleName,
                articleDescription: editData.articleDescription,
                icon: editData.icon,
                iconType: editData.iconType,
                isPublic: editData.isPublic,
                isSharedInSocialMedia: editData.isSharedInSocialMedia,
                isActive: editData.isActive,
                attachmentURL: '',
                isPublishInNews: editData.isPublishInNews,
            }
            await SaveArtical(dispatch, datatodave, 0)
                .then((result) => {
                    if (result !== null && result !== undefined) {
                        onclose()
                    }
                })
                .catch(() => {})
        } catch (error) {
            ErrorMessage('Error deleting S3 object:')
        }
    }
    return (
        <div>
            <Card>
                <Table
                    columns={Servicecolumns}
                    dataSource={[
                        {
                            key: data,
                            attachmentPath: data.substring(
                                data.lastIndexOf('/') + 1
                            ),
                        },
                    ]}
                    pagination={false}
                />
            </Card>
            <Modal
                width={'60%'}
                open={visible}
                onCancel={() => {
                    setVisible(false)
                }}
                footer={null}
            >
                {imagePath !== '' ? (
                    imagePath.includes('.pdf') ? (
                        <iframe
                            title="PDF Viewer"
                            src={imagePath}
                            style={{
                                width: '100%',
                                height: '80vh',
                                border: 'none',
                            }}
                        />
                    ) : (
                        <img
                            src={imagePath}
                            alt="View"
                            style={{ width: '100%', marginTop: '20px' }}
                        />
                    )
                ) : (
                    <div>Error loading file</div>
                )}
            </Modal>
        </div>
    )
}

export default DocumentViewModelForm
